import { useEffect } from "react";
import { useAnalyticSimpleActionDispatch } from "~/analytics/Analytics";
import { PlatformHubUpsellContent } from "./PlatformHubUpsellContent";
export function PlatformHubUpsellPage() {
    const dispatchAction = useAnalyticSimpleActionDispatch();
    const trackOpeningRequestDialog = () => dispatchAction("Request Platform Hub trial dialog opened");
    useEffect(() => {
        dispatchAction("View Platform Hub Upsell page");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const description = (<div>
            <p>In Platform Hub, you can create reusable, standardised blocks of steps for deployment processes or runbooks.</p>
            <p>Ensure that your teams are compliant and secure by default with policies. You can craft and manage deployment rules that can be applied across projects and spaces.</p>
        </div>);
    return (<PlatformHubUpsellContent title="Standardize your deployment processes and enforce policies with Platform Hub" description={description} featureName="Platform Hub" onRequestTrial={async (repository) => {
            await repository.PlatformHub.requestTrial();
        }} onTrialRequested={() => dispatchAction("Request for Platform Hub trial submitted")} trackOpeningRequestDialog={trackOpeningRequestDialog}/>);
}
